import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import TableSkeleton from "../../common-components/TableSkeleton";
import {
  convertStraight,
  formatDateTimezon,
  convertTo12HourFormat,
} from "../../common-data/Converts";
import {
  CheckCircleIcon,
  RedCrossIcon,
  DownloadIcon,
} from "../../../images/icons/icons";

const ThreeDayPTMembers = ({
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  setModValues,
}) => {
  const { threeDayPTTrial, threeDayPTTrialLoading, threeDayPTTrialError } =
    useSelector((state) => state.plans);

  const handleBCAReportDownload = (reportUrl, memberName) => {
    if (reportUrl) {
      const link = document.createElement("a");
      link.href = reportUrl;
      link.target = "_blank";
      link.download = `BCA_Report_${memberName}_${Date.now()}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const iniDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniDatas);

  useEffect(() => {
    if (
      !threeDayPTTrialLoading &&
      !threeDayPTTrialError &&
      threeDayPTTrial?.status &&
      threeDayPTTrial?.data?.length > 0
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: threeDayPTTrial.data,
        pagination:
          threeDayPTTrial?.pagination?.length > 0
            ? threeDayPTTrial.pagination
            : [],
      }));
    } else {
      setAllDatas(iniDatas);
    }
  }, [threeDayPTTrialLoading, threeDayPTTrialError, threeDayPTTrial]);

  const tbColumn = [
    {
      dataField: "user_id",
      text: "Member",
      formatter: (_, row) => (
        <span
          className="tb-data text-start link"
          onClick={() =>
            setModValues((prevs) => ({
              ...prevs,
              isModOpen: true,
              modName: "trial_history",
              rowData: row,
            }))
          }
        >
          {row?.user_name || "NA"}
          <br />
          {(row?.user_mobile || row?.user_email) && (
            <small className="underline lowercase">
              {row?.user_mobile || ""}
              <br />
              {row?.user_email || ""}
            </small>
          )}
        </span>
      ),
    },
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (_, row) => (
        <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
      ),
    },
    {
      dataField: "trainer_name",
      text: "Trainer",
      formatter: (_, row) => (
        <span
          className="tb-data text-start"
          // onClick={() =>
          //   setModValues((prevs) => ({
          //     ...prevs,
          //     isModOpen: true,
          //     modName: "shift_details",
          //     rowData: row,
          //   }))
          // }
        >
          {row?.trainer_name || "NA"}
          <br />
          {row?.trainer_mobile && (
            <small className="underline lowercase">
              {row?.trainer_mobile || ""}
            </small>
          )}
        </span>
      ),
    },
    {
      dataField: "three_day_assigned",
      text: "3 day trial assigned",
      formatter: (_, row) => (
        <span
          className="tb-data icon"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {row?.three_day_assigned ? <CheckCircleIcon /> : <RedCrossIcon />}
        </span>
      ),
    },
    {
      dataField: "bca_report_status",
      text: "BCA status",
      formatter: (_, row) => {
        const isBCACompleted =
          row?.bca_report_status?.toLowerCase() === "completed";

        return (
          <span
            className="tb-data icon"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {isBCACompleted ? (
              <button
                type="button"
                className="btn btn-link p-0"
                onClick={() =>
                  handleBCAReportDownload(row?.bca_report, row?.user_name)
                }
                style={{
                  background: "none",
                  border: "none",
                  color: "#28a745",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                title="Download BCA Report"
              >
                <DownloadIcon size={20} />
              </button>
            ) : (
              <RedCrossIcon />
            )}
          </span>
        );
      },
    },
    {
      dataField: "pt_schedule_date",
      text: "Trial Schedule Date",
      formatter: (_, row) => (
        <span className="tb-data minWidth100">
          {row?.pt_schedule_date ? convertStraight(row.pt_schedule_date) : "-"}
        </span>
      ),
    },
    {
      dataField: "three_day_trial_dates",
      text: "3 Day Trial Duration",
      formatter: (_, row) => (
        <span className="tb-data minWidth120 underline tb-col">
          {row?.three_day_start_date
            ? formatDateTimezon(row.three_day_start_date)
            : "-"}
          <br />
          {row?.three_day_expire_date
            ? formatDateTimezon(row.three_day_expire_date)
            : "-"}
        </span>
      ),
    },
    {
      dataField: "start_time",
      text: "Slot Time",
      formatter: (_, row) => {
        const startTime = row?.start_time
          ? convertTo12HourFormat(row.start_time)
          : "-";
        const endTime = row?.end_time
          ? convertTo12HourFormat(row.end_time)
          : "-";
        return (
          <span className="tb-data minWidth100">
            {startTime} - {endTime}
          </span>
        );
      },
    },
    {
      dataField: "day_no",
      text: "Current Day",
      formatter: (_, row) => (
        <span className="tb-data minWidth80">
          {row?.day_no ? row.day_no.replace("_", " ").toUpperCase() : "-"}
        </span>
      ),
    },
    {
      dataField: "three_day_done_count",
      text: "Sessions Done",
      formatter: (_, row) => (
        <span className="tb-data minWidth80">
          {row?.three_day_done_count || "0"}
        </span>
      ),
    },

    {
      dataField: "plan_name",
      text: "plan Name",
      formatter: (_, row) => (
        <span className="tb-data minWidth100">{row?.plan_name || "NA"}</span>
      ),
    },
    {
      dataField: "subscription_created_date",
      text: "Plan Duration",
      formatter: (_, row) => (
        <span className="tb-data minWidth100 underline tb-col">
          {row?.subscription_start_date
            ? formatDateTimezon(row.subscription_start_date)
            : "-"}
          <br />
          {row?.subscription_expire_date
            ? formatDateTimezon(row.subscription_expire_date)
            : "-"}
        </span>
      ),
    },
    {
      dataField: "actions",
      text: "Actions",
      formatter: (_, row) => {
        return (
          <div className="pp-employee-payroll-actions">
            <button
              key="send-email"
              type="button"
              className={`pp-employee-payroll-action-button`}
              style={{
                background: "#cd0909",
                color: "#fff",
                // cursor: row?.three_day_assigned ? "not-allowed" : "pointer",
                // opacity: row?.three_day_assigned ? 0.5 : 1,
              }}
              onClick={() =>
                // !row?.three_day_assigned &&
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "trial_assign",
                  rowData: row,
                }))
              }
              // disabled={row?.three_day_assigned}
            >
              trial assign
            </button>
          </div>
        );
      },
    },
  ];

  return (
    <div
      className="pp-employee-payroll-table-wrapper pp-no-border-table mt30"
      // className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt30"
    >
      {threeDayPTTrialLoading ? (
        <TableSkeleton columns={10} rows={10} />
      ) : (
        <PaymentLinkTable
          tableData={allDatas.allData}
          tableColumns={tbColumn}
          tablePagination={allDatas.pagination}
          isPage={isPage}
          setIsPage={(value) => setIsPage(value)}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
        />
      )}
    </div>
  );
};

export default ThreeDayPTMembers;
